<template>
  <v-row
    justify=center>
    <v-col
      cols=auto>
      <v-sheet
        color="primary"
        max-width=700>
        <v-container
          fluid>
          <v-row
            no-gutters>
            <v-col
              v-show="$vuetify.breakpoint.mdAndUp"
              cols=2>
              <v-container
                fill-height>
                <v-row
                  justify=center
                  align=center>
                  <v-col
                    cols=auto>
                    <v-icon
                      large
                      dark>fas fa-chalkboard-teacher</v-icon>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
            <v-col
              cols=12
              sm=12
              md=8>
              <v-container
                fluid>
                <v-row
                  justify=center
                  no-gutters>
                  <v-col
                  cols=auto>
                    <h2 class="white--text">無料体験実施中</h2>
                  </v-col>
                </v-row>
                <v-row
                  justify=center>
                  <v-col
                    cols=auto
                    >
                    <v-btn
                      rounded
                      x-large
                      color="white"
                      dark
                      class="main--text primary--text font-weight-bold"
                      to="/redirect/to-line"
                      target="_blank"
                      >▶無料お問い合わせはコチラ
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row
                  justify=center
                  no-gutters>
                  <h4 class="white--text">まずはお気軽に<br>ご相談ください</h4>
                </v-row>
              </v-container>
            </v-col>
            <v-col
              v-show="$vuetify.breakpoint.mdAndUp"
              cols=2>
              <v-container
                fill-height>
                <v-row
                  justify=center
                  align=center>
                  <v-col
                    cols=auto>
                    <v-icon
                      large
                      dark>fas fa-child</v-icon>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
export default {
  
}
</script>
